import { SET_LANGUAGE } from "REDUX/constants";

export default function changeLanguage(language) {
  return {
    type: SET_LANGUAGE,
    data: {
      language: language,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/ChangeLanguage.js